module.exports = __webpack_public_path__ + "img/google.88d46962.png";